import { SafeTypes, TablePlan, Plan, Operation, Coverage } from "domain/models/SurgirSafe"

export const SAFE_TYPES: SafeTypes[] = [
  {
    title: 'Muerte natural',
    description: 'Fallecimiento del asegurado por causas distintas a un accidente.',
    showDescription: false,
    className: "card-one",
    classNameSecondary: "card-one-dark",
    alt: 'Muerte Natural Super Seguro Cobertura Seguro Vida'
  },
  {
    title: 'Muerte accidental',
    description: 'Fallecimiento del asegurado como consecuencia directa e inmediata de un accidente.',
    showDescription: false,
    className: "card-two",
    classNameSecondary: "card-two-dark",
    alt: 'Muerte Accidental Super Seguro Cobertura Seguro Vida'
  },
  {
    title: 'Muerte accidental en transporte público',
    description: 'Fallecimiento del asegurado por un accidente en un medio de transporte público terrestre con rutas preestablecidas.',
    showDescription: false,
    className: "card-three",
    classNameSecondary: "card-three-dark",
    alt: 'Muerte Accidental en transporte público Super Seguro Cobertura Seguro Vida'
  },
  {
    title: 'Indemnización diaria por hospitalización',
    description: 'Cuando el asegurado sea hospitalizado a consecuencia de un accidente o de una enfermedad, se le pagará la renta diaria indicada en la póliza.',
    showDescription: false,
    className: "card-four",
    classNameSecondary: "card-four-dark",
    alt: 'Indemnización diaria por hospitalización Super Seguro Cobertura Seguro Vida'
  },
  {
    title: 'Desamparo súbito familiar',
    description: 'Si a consecuencia de un mismo accidente, amparado por el presente seguro, fallecieran el asegurado y su cónyuge.',
    showDescription: false,
    className: "card-five",
    classNameSecondary: "card-five-dark",
    alt: 'Desamparo súbito familiar Super Seguro Cobertura Seguro Vida'
  }
  ,{
    title: 'Indemnización por sepelio',
    description: 'Reembolso de los gastos de sepelio en los que se hubiera incurrido como consecuencia del fallecimiento del asegurado.',
    showDescription: false,
    className: "card-six",
    classNameSecondary: "card-six-dark",
    alt: 'Indemnización por sepelio Super Seguro Cobertura Seguro Vida'
  }
]

export const TABLE_PLANS: TablePlan[] = [
  {
    icon: 'telefonica',
    titlePlan: 'Orientación médica telefónica *',
    values : [
      {
        title: '',
        amount: 'S/ 0',
        description: false,
        id: 19
      },
      {
        title: '',
        amount: 'S/ 0',
        description: false,
        id: 20
      },
      {
        title: '',
        amount: 'S/ 0',
        description: false,
        id: 21
      },
    ]
  },
  {
    icon: 'martillo',
    titlePlan: 'Gasfitería *',
    values : [
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 22
      },
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 23
      },
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 24
      },
    ]
  },
  {
    icon: 'enchufe',
    titlePlan: 'Electricidad *',
    values : [
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 25
      },
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 26
      },
      {
        title: 'Copago',
        amount: 'S/ 250',
        description: false,
        id: 27
      },
    ]
  },
  {
    icon: 'llave',
    titlePlan: 'Cerrajería *',
    values : [
      {
        title: 'Copago',
        amount: 'S/ 90',
        description: false,
        id: 28
      },
      {
        title: 'Copago',
        amount: 'S/ 90',
        description: false,
        id: 29
      },
      {
        title: 'Copago',
        amount: 'S/ 90',
        description: false,
        id: 30
      },
    ]
  },
  {
    icon: 'hospital',
    titlePlan: 'Indemnización diaria por hospitalización**',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 50',
        description: true,
        id: 10
      },
      {
        title: 'Hasta',
        amount: 'S/ 75',
        description: true,
        id: 11
      },
      {
        title: 'Hasta',
        amount: 'S/ 75',
        description: true,
        id: 12
      },
    ]
  },
  {
    icon: 'plant',
    titlePlan: 'Muerte natural',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 750',
        id: 1,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 1,000',
        id: 2,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 1,000',
        id: 3,
        description: false,
      },
    ]
  },
  {
    icon: 'zap',
    titlePlan: 'Muerte accidental',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 3,500',
        id: 4,
        description: false,

      },
      {
        title: 'Hasta',
        amount: 'S/ 6,500',
        id: 5 ,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 10,000',
        id: 6,
        description: false,
      },
    ]
  },
  {
    icon: 'car',
    titlePlan: 'Muerte accidental en transporte público',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 1,000',
        id: 7 ,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 2,000',
        id: 8,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 3,000',
        id: 9,
        description: false,
      },
    ]
  },
  {
    icon: 'family',
    titlePlan: 'Desamparo súbito familiar',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 3,500',
        id: 13,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 5,000',
        id: 14,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 8,000',
        id: 15,
        description: false,
      },
    ]
  },
  {
    icon: 'drop',
    titlePlan: 'Indemnización por sepelio',
    values : [
      {
        title: 'Hasta',
        amount: 'S/ 1,500',
        id: 16,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 1,800',
        id: 17,
        description: false,
      },
      {
        title: 'Hasta',
        amount: 'S/ 1,800',
        id: 18,
        description: false,
      },
    ]
  }
]

export const PLANS: Plan[] = [
  { title: 'Plan 4', amount: 'S/ 15', description: 'al mes'},
  { title: 'Plan 5', amount: 'S/ 25', description: 'al mes'},
  { title: 'Plan 6', amount: 'S/ 33', description: 'al mes'}
]

export const OPERATIONS: Operation[] = [
  { title: 'Elige un Certificado' , description: 'Elige el certificado del valor del vehículo que quieres (USD 10,000 / 15,000 / 20,000, etc)' },
  { title: 'Regístrate', description: 'Regístrate para que te evalúen' },
  { title: 'Paga tu inscripción', description: 'Paga tu cuota de inscripción y primera cuota para asegurar tu cupo en la asamblea' },
]

export const COVERAGE: Coverage[] = [
  { 
    icon: 'orientacion',
    title: 'Orientación médica telefónica',
    description: 'Atención y asesoramiento sobre todas las dudas de carácter médico que el asegurado desee plantear.',
  },
  { 
    icon: 'gasfiteria',
    title: 'Gasfitería',
    description: 'En caso de rotura de tuberías, estanques de agua, llaves u otras instalaciones fijas de agua.',
  },
  { 
    icon: 'electricidad',
    title: 'Electricidad',
    description: 'Por falta de energía eléctrica, producida como consecuencia de una falla o avería de las instalaciones eléctricas.',
  },
  { 
    icon: 'cerrajeria',
    title: 'Cerrajería',
    description: 'Ante pérdida, extravío o robo de llaves o inutilización de chapas o cerraduras a consecuencia de robo u otra causa accidental.',
  },
  { 
    icon: 'hospital',
    title: 'Indemnización diaria por hospitalización',
    description: 'Cuando el asegurado sea hospitalizado a consecuencia de un accidente o de una enfermedad, se le pagará la renta diaria indicada en la póliza.',
  },
  { 
    icon: 'natural',
    title: 'Muerte natural',
    description: 'Fallecimiento del asegurado por causas distintas a un accidente.',
  },
  { 
    icon: 'accidental',
    title: 'Muerte accidental',
    description: 'Fallecimiento del asegurado como consecuencia directa e inmediata de un accidente.',
  },
  { 
    icon: 'transporte',
    title: 'Muerte accidental en transporte público',
    description: 'Fallecimiento del asegurado por un accidente en un medio de transporte público terrestre con rutas preestablecidas.',
  },
  { 
    icon: 'familiar',
    title: 'Desamparo súbito familiar',
    description: 'Si a consecuencia de un mismo accidente, amparado por el presente seguro, fallecieran el asegurado y su cónyuge.',
  },
  { 
    icon: 'sepelio',
    title: 'Indemnización por sepelio',
    description: 'Reembolso de los gastos de sepelio en los que se hubiera incurrido como consecuencia del fallecimiento del asegurado.',
  }

]